import React from 'react'
import ReactDOM from 'react-dom'
import ContactForm from './ContactForm';

ReactDOM.render(<ContactForm />, document.getElementById('contact'))
